const JobApplicationNotice = () => {
  return (
    <div className="text-[#664d03] bg-[#fff3cd] border border-[#ffecb5] p-4 rounded">
      <strong className="font-semibold block mb-2">Before you apply:</strong>
      <ul className="list-disc list-inside space-y-1 text-sm">
        <li>Please only apply if you are legally able to work in the country of this role.</li>
        <li>Ensure that you are uploading a resume. Applications without one cannot be considered.</li>
      </ul>
    </div>
  )
}

export default JobApplicationNotice
